import { Injectable } from '@angular/core';

@Injectable({ providedIn: 'root' })
export class LocalStorageService {
    public getShipyardViewModeLocked(shipyardId: string): string {
        return localStorage.getItem(`icreate.shipyard.view-mode.locked.${shipyardId}`);
    }

    public setShipyardViewModeLocked(shipyardId: string, isLocked: boolean): void {
        localStorage.setItem(`icreate.shipyard.view-mode.locked.${shipyardId}`, String(isLocked));
    }

    public isVesselAndShipyardGridView(shipyardId: string): boolean {
        const displayGridView = localStorage.getItem(`icreate.shipyard.view-mode.list.${shipyardId}`);
        return displayGridView ? displayGridView === 'true' : true;
    }

    public setShipyardViewMode(shipyardId: string, isShowingList: boolean): void {
        localStorage.setItem(`icreate.shipyard.view-mode.list.${shipyardId}`, String(isShowingList));
    }

    public getCurrentVesselId(): string {
        return localStorage.getItem('currentVessel');
    }

    public setCurrentVesselId(id: string): void {
        localStorage.setItem('currentVessel', id);
    }

    public getPanelsState(): string {
        return localStorage.getItem('@frango.webeditor.panelsState');
    }

    public setPanelsState(panelsState: string): void {
        localStorage.setItem('@frango.webeditor.panelsState', panelsState);
    }

    public getCurrentViewId(): string {
        return localStorage.getItem('@frango.webeditor.currentview');
    }

    public setCurrentViewId(view: string): void {
        localStorage.setItem('@frango.webeditor.currentview', view);
    }
}
